<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12" v-if="allowAdd">
      <el-button
        small
        class="mb-3"
        color="primary"
        icon="pridėti"
        :title="mandateData.parent_id ? 'Pridėti perįgaliotinį' : 'Pridėti įgaliotinį'"
        :loading="loading"
        @click.native.stop="newRepresentative()"
      />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" v-if="showTogether && persons.length > 1">
      <el-checkbox v-if="mandateData.parent_id"
          :disabled="togetherDisabled"
          class="mt-0 mb-1"
          style="width: fit-content"
          label="Veikia kartu"
          v-model=" mandateData.sub_representitives_together"
        />
        <el-checkbox v-else
          :disabled="togetherDisabled"
          class="mt-0 mb-1"
          style="width: fit-content"
          label="Veikia kartu"
          v-model=" mandateData.representitives_together"
        />
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        class="mb-4 custom-table"
        :loading="loading"
        :headers="headers"
        item-key="custom_key"
        :items="setCustomKey(persons)"
        :hide-default-footer="true"
        :items-per-page="1000"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal'),
        }"
      >
        <!--  -->
        <template #[`item.index`]="{ item, index }">
          <td class="pr-0 pl-2">{{ formatedIndex(index) }}</td>
        </template>
        <template #[`item.contact_row`]="{ item }">
          <td v-if="!contactLoading"><person-contact-row :item="item"></person-contact-row></td>
        </template>
        <template #[`item.code`]="{ item }">
          {{ item.code || item.iltu_code }}
        </template>


        <template #[`item.actions`]="{ item, index }">
          <div class="nowrap">
            <el-table-action v-if="allowAdd"
              :item="setRepresentitivesParams(item, tableKey, index)"
              @editContacts="editContacts(item)"
              @deleteItem="deleteItem({ item, type: tableKey })"
              @showPersonDocument="showPersonDocument(item)"
            />
            <el-table-action v-else-if="canEditContacts"
              :item="setEditContacts(item)"
              @editContacts="editContacts(item)"
              @showPersonDocument="showPersonDocument(item)"
            />
            <el-table-action v-else
              :item="setShowPersonDocument(item)"
              @showPersonDocument="showPersonDocument"
            />
          </div>
        </template>

      </v-data-table>
    </v-col>
    <!-- modal  -->
    <modal-delete v-if="allowAdd"
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      :modalType="modalType"
      :additionalData="additionalData"
      :allowForeignJur="allowForeignJur"
      @addPersonData="addPerson"
      showForeignerPp
      :checkBeforeAddRaw="isErrorsCorrectionInaccuracies"
      :addRaw="!isErrorsCorrectionInaccuracies"
      mandate
    />
    <modal-contact-form
      v-if="showContactModal"
      v-model="showContactModal"
      :item="selectedContact"
      @reloadContact="reloadContact"
    />
    <modal-person-document
      v-if="showPersonDocumentModal"
      v-model="showPersonDocumentModal"
      :item="selectedPersonDocument"
      :readonly="onlyView"
      upload-mode="array"
      @files-added-to-person="handlePersonDocumentFilesAdded"
      @file-removed-from-person="handlePersonDocumentFileRemoved"
    />
  </v-row>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import ModalContactForm from '@/components/modals/ModalContactForm.vue'
import ModalPersonDocument from '@/components/modals/ModalPersonDocument.vue'
import PersonContactRow from '@/components/iregTableRows/PersonContactRow.vue'
import InJournalTypes from '@/components/constants/inJournalTypes'

export default {
  name: 'RepresentitivesForm',
  components: {
    ModalAddPerson,
    ModalDelete,
    ModalContactForm,
    ModalPersonDocument,
    PersonContactRow,
  },
  props: {
    onlyView: Boolean,
    persons: [Array, Object],
    allowAdd: Boolean,
    canEditContacts: Boolean,
    tableKey: String,
    showTogether: Boolean,
    mandateData: Object,
    allowForeignJur: [Boolean, String],
    inJournalType: [String],
  },
  data() {
    return {
      showContactModal: false,
      selectedContact: {},
      pageloading: false,
      loading: false,
      showAddPerson: false,
      modalType: null,
      showDelete: false,
      modalDeleteItem: null,
      contactLoading: false,
      showPersonDocumentModal: false,
      selectedPersonDocument: {},
    }
  },
  computed: {
    isErrorsCorrectionInaccuracies() {
      return this.inJournalType == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
    },
    additionalData() {
      return {
        principals: this.mandateData.principals,
        representitives: this.persons,
        sub_representitives: this.mandateData.sub_representitives,
      };
    },
    togetherDisabled() {
      return [
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA,
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA,
        InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA,
        InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA
      ].includes(this.inJournalType) || this.onlyView
    },
    togetherList() {
      return [
        { label: 'Veikimas kartu', value: true },
        { label: 'Veikimas atskirai', value: false },
      ]
    },
    showOperationRepresentitivesType() {
      return this.persons?.length > 1
    },
    headers() {
      let headers = [
        {
          text: '',
          align: 'start',
          value: 'index',
          sortable: false,
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Vardas pavardė / Pavadinimas'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Asmens dokumentas'),
          align: 'start',
          value: 'person_document_kind_title_lt',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
      return headers
    },
  },
  methods: {
    setCustomKey(persons) {
      persons.map((person, key) => persons[key].custom_key = person.id + person.amn_id + person.fullname + person.code + person.foreigner_code)
      return persons
    },
    reloadContact() {
      this.contactLoading = true;
      this.$nextTick(() => {
        this.contactLoading = false
      })
    },
    formatedIndex(index, subIndex) {
      if (subIndex != undefined) {
        this.persons[index].jur_representers[subIndex].order_no =
          subIndex + 1
        return `${index + 1}.${subIndex + 1}.`
      }
      this.persons[index].order_no = index + 1
      return `${index + 1}.`
    },
    newRepresentative() {
      this.modalType = this.tableKey
      this.showAddPerson = true
    },
    addPerson(item) {
      item.addJurRepresenter = false
      this.persons.push(item)
      this.showAddPerson = false
    },
    formatedRepresentitivesIndex(index) {
      this.persons[index].order_no = index + 1
    },
    setRepresentitivesParams(item, type, index) {
      this.$set(item, 'showPersonDocument', (item.person_documents && item.person_documents.length) || item.person_document_files || item.person_document_kind_id)
      if (
        (type === 'principals' || type === 'jur_representers') &&
        this.subMandate
      ) {
        return item
      }
      this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
      this.formatedRepresentitivesIndex(index)
      item.canDelete = this.allowAdd;
      return item
    },
    setShowPersonDocument(item) {
      this.$set(item, 'showPersonDocument', (item.person_documents && item.person_documents.length) || item.person_document_files || item.person_document_kind_id)
      return item
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = this.allowAdd;
    },
    editContacts(item) {
      item.phone_number_prepend = item.phone_number_prepend || '+370'
      item.phone_number = item.phone_number || ''
      item.email_address = item.email_address || ''
      this.selectedContact = item
      this.showContactModal = true
    },
    showPersonDocument(item) {
      this.selectedPersonDocument = item
      this.showPersonDocumentModal = true
    },
    setEditContacts(item) {
      this.setShowPersonDocument(item)
      this.$set(item, 'canEditContacts', item.type == 'FIZ' && this.canEditContacts)
      item.canDelete = false;
      return item
    },
    confirmDelete(item) {
      const index = this.persons.findIndex(
        (formItem) => {
          if (formItem.amn_id && formItem.amn_id && formItem.amn_id != 'new_id') {
            return formItem.amn_id === item.item.amn_id
          } else {
            return formItem.amn_id === item.item.amn_id && formItem.fullname === item.item.fullname
          }
        }
      )
      if (index > -1) {
        this.persons.splice(index, 1)
      }
      this.showDelete = false
    },

    handlePersonDocumentFilesAdded(addedFiles) {
      // Files have been added to the person's file array
      // The files are already added to selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', `${addedFiles.length} file(s) added to person document`)
    },

    handlePersonDocumentFileRemoved(removedFile) {
      // File has been removed from the person's file array
      // The file is already removed from selectedPersonDocument.person_document_files
      // Just show success message
      this.$root.$emit('DATA_SUCCESS', 'File removed from person document')
    },
  },
}
</script>

<style>
</style>
